export default function (value) {
  return arguments.length ? this.property("__data__", value) : this.node().__data__;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-selection@1.4.1@d3-selection/src/selection/datum.js
// module id = 450
// module chunks = 0